import { render, staticRenderFns } from "./ObservationsReportMailPopup.vue?vue&type=template&id=4b595e5e&"
import script from "./ObservationsReportMailPopup.vue?vue&type=script&lang=js&"
export * from "./ObservationsReportMailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports